/* Zappycards — behaviour for the product pages.
   No framework. Drop in after the markup, or defer it.
   Everything is driven off data- attributes so the same file
   serves the card PDP and the stand PDP. */

(function () {
  'use strict';

  var money = function (n) { return '$' + n.toFixed(2); };

  /* ---------------- buy box ---------------- */
  function initBuyBox(root) {
    var tiers = JSON.parse(root.dataset.tiers);          // [[minQty, unitPrice], ...] high → low
    var noun = root.dataset.noun || 'Card';
    var nounPlural = root.dataset.nounPlural || noun + 's';
    var freeShipAt = parseInt(root.dataset.freeShipAt, 10) || 5;
    var qty = parseInt(root.dataset.defaultQty, 10) || 1;

    var packs = Array.prototype.slice.call(root.querySelectorAll('[data-pack]'));
    // NodeLists: the card PDP repeats the stepper + CTA in its pricing section and both mirror one qty
    var counts = root.querySelectorAll('[data-qty-count]');
    var unitEl = root.querySelector('[data-price-unit]');
    var totalEl = root.querySelector('[data-price-total]');
    var shipEl = root.querySelector('[data-ship-line]');
    var ctas = root.querySelectorAll('[data-cta-label]');
    var sticky = document.querySelector('[data-sticky-bar]');

    function unitFor(q) {
      for (var i = 0; i < tiers.length; i++) if (q >= tiers[i][0]) return tiers[i][1];
      return tiers[tiers.length - 1][1];
    }

    function render() {
      var unit = unitFor(qty);
      var total = qty * unit;
      var label = qty + ' ' + (qty === 1 ? noun : nounPlural);

      packs.forEach(function (p) {
        p.setAttribute('aria-pressed', String(parseInt(p.dataset.pack, 10) === qty));
      });
      counts.forEach(function (c) { c.textContent = qty; });
      if (unitEl) unitEl.textContent = qty + ' × ' + money(unit) + ' per ' + noun.toLowerCase();
      if (totalEl) totalEl.textContent = money(total);
      if (shipEl) shipEl.textContent = qty >= freeShipAt ? '' : 'Free shipping on ' + freeShipAt + ' or more';
      ctas.forEach(function (c) { c.textContent = 'Add ' + label; });

      if (sticky) {
        var sName = sticky.querySelector('[data-sticky-name]');
        var sPrice = sticky.querySelector('[data-sticky-price]');
        if (sName) sName.textContent = sticky.dataset.product + ' · ' + label;
        if (sPrice) sPrice.textContent = money(total) + ' total';
      }
      root.dataset.qty = qty;
    }

    packs.forEach(function (p) {
      p.addEventListener('click', function () { qty = parseInt(p.dataset.pack, 10); render(); });
      p.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); p.click(); }
      });
    });

    /* Dead-zone guard: with stepped tiers, a quantity just under a tier can cost
       as much as or MORE than the tier itself (e.g. 4 x $25 = $100 vs 5 x $20 = $100,
       or 8 x $20 = $160 vs 10 x $15 = $150). Never let the stepper land there:
       stepping up jumps to the tier, stepping down drops to the last quantity
       that is still strictly cheaper than the tier. */
    function snap(q, dir) {
      for (var i = 0; i < tiers.length; i++) {
        var m = tiers[i][0], p = tiers[i][1];
        if (q < m && q * unitFor(q) >= m * p) return dir > 0 ? m : Math.floor((m * p - 1) / unitFor(q));
      }
      return q;
    }

    root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.dataset.qtyStep, 10);
        qty = snap(Math.min(99, Math.max(1, qty + step)), step);
        render();
      });
    });

    render();
  }

  /* ---------------- gallery ---------------- */
  function initGallery(root) {
    var frame = root.querySelector('[data-gallery-frame]');
    var img = frame.querySelector('img');
    var video = frame.querySelector('video');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-index]'));
    var track = root.querySelector('[data-gallery-track]');

    function show(i) {
      var t = thumbs[i];
      if (!t) return;
      var isVideo = t.dataset.videoSrc;
      thumbs.forEach(function (x, n) { x.setAttribute('aria-current', String(n === i)); });
      if (isVideo && video) {
        img.hidden = true; video.hidden = false;
        if (!video.src) video.src = t.dataset.videoSrc;
        video.muted = true;
        video.play().catch(function () {});
      } else {
        if (video) { video.pause(); video.hidden = true; }
        img.hidden = false;
        img.src = t.dataset.full;
        img.alt = t.dataset.alt || '';
      }
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(i); }
      });
    });

    root.querySelectorAll('[data-gallery-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollBy({ left: parseInt(b.dataset.galleryScroll, 10), behavior: 'smooth' });
      });
    });

    show(0);
  }

  /* ---------------- tabs ---------------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = (i + d + tabs.length) % tabs.length;
        select(n); tabs[n].focus();
      });
    });
    function select(i) {
      tabs.forEach(function (tab, n) {
        var on = n === i;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        document.getElementById(tab.getAttribute('aria-controls')).hidden = !on;
      });
    }
    select(0);
  }

  /* ---------------- accordion ---------------- */
  function initAccordion(root) {
    var qs = Array.prototype.slice.call(root.querySelectorAll('.faq__q'));
    qs.forEach(function (q) {
      q.addEventListener('click', function () {
        var open = q.getAttribute('aria-expanded') === 'true';
        qs.forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          document.getElementById(other.getAttribute('aria-controls')).hidden = true;
        });
        if (!open) {
          q.setAttribute('aria-expanded', 'true');
          document.getElementById(q.getAttribute('aria-controls')).hidden = false;
        }
      });
    });
  }

  /* ---------------- sticky add to cart ----------------
     Shown only once the real buy box has scrolled out of view. */
  function initSticky(bar) {
    // [data-sticky-anchor] lets the buybox root span the page while the bar watches just the hero buy box
    var anchor = document.querySelector('[data-sticky-anchor]') || document.querySelector('[data-buybox]');
    if (!anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      // show only once the buy box has scrolled ABOVE the viewport — not while it is still below the fold
      bar.dataset.shown = String(!entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------------- hero carousel (homepage) ---------------- */
  function initCarousel(root) {
    var slides = JSON.parse(root.dataset.slides);
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slide-dot]'));
    var eyebrow = root.querySelector('[data-slide-eyebrow]');
    var title = root.querySelector('[data-slide-title]');
    var sub = root.querySelector('[data-slide-sub]');
    var img = root.querySelector('[data-slide-img]');
    var i = 0, timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function render() {
      var s = slides[i];
      eyebrow.textContent = s.eyebrow;
      title.textContent = s.title;
      sub.textContent = s.sub;
      img.src = s.img;
      img.parentElement.style.background = s.frameBg;
      dots.forEach(function (d, n) { d.setAttribute('aria-current', String(n === i)); });
    }
    function start() { if (!reduced) timer = setInterval(function () { i = (i + 1) % slides.length; render(); }, 6000); }
    function stop() { clearInterval(timer); timer = null; }

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { stop(); i = n; render(); });
    });
    render(); start();
  }

  /* ---------------- boot ---------------- */
  document.querySelectorAll('[data-buybox]').forEach(initBuyBox);
  document.querySelectorAll('[data-gallery]').forEach(initGallery);
  document.querySelectorAll('[data-tabs]').forEach(initTabs);
  document.querySelectorAll('[data-accordion]').forEach(initAccordion);
  document.querySelectorAll('[data-sticky-bar]').forEach(initSticky);
  document.querySelectorAll('[data-carousel]').forEach(initCarousel);
})();